// extracted by mini-css-extract-plugin
export default {"container":"Products_container__5EBU6","products":"Products_products__dqFmW","menu":"Products_menu__49Zbb","list":"Products_list__5n+1K","product":"Products_product__meum8"};